import { gql } from "@apollo/client"

export const ADD_OBSERVATION = gql`
  mutation insert_observation(
    $data: jsonb!
    $observation_date: timestamptz
    $location_id: Int!
    $payload_version: String!
  ) {
    insert_observation_one(
      object: {
        data: $data
        observation_date: $observation_date
        location_id: $location_id
        payload_version: $payload_version
      }
    ) {
      id
    }
  }
`
